import { OrgUserSearchParams, Persona } from '@cibo/core'
import { AcresGtChip, AcresLtChip, FilterChip, FipsChip } from '@cibo/ui'
import { TFunction } from 'i18next'
import { filter } from 'ramda'
import { useOrganizationList } from '../../../hooks'

type FilterChipProps = {
  searchValues: OrgUserSearchParams
  handleUpdate: (newFilters: OrgUserSearchParams) => void
  t: TFunction
}

export const UserSearchChipComponents = {
  isActive: ({ searchValues: { isActive, ...otherFilters }, handleUpdate, t }: FilterChipProps) =>
    !isActive ? (
      <FilterChip onDelete={() => handleUpdate(otherFilters)} label={t('inactiveUsers')} />
    ) : null,
  persona: ({
    searchValues: { persona = [], ...otherFilters },
    handleUpdate,
    t,
  }: FilterChipProps) => {
    const onDelete = (personaVal: Persona) => () => {
      // @ts-ignore filter is having a hard time with the dictionary
      const otherPersonas = filter((label: Persona) => label !== personaVal, persona)
      handleUpdate({ ...otherFilters, persona: otherPersonas })
    }
    return (
      <>
        {(typeof persona === 'string' ? [persona] : persona)?.map(personaVal => (
          <FilterChip
            key={personaVal}
            onDelete={onDelete(personaVal)}
            label={t(`persona_${personaVal}`)}
          />
        ))}
      </>
    )
  },
  orgId: ({ searchValues: { orgId, ...otherFilters }, handleUpdate, t }: FilterChipProps) => {
    // eslint-disable-next-line
    const organizations = useOrganizationList()
    if (organizations.isLoading || organizations.isFetching) {
      return null
    }
    const org = organizations.data?.find(a => a.id === orgId)
    if (!org || !org.label) {
      return null
    }
    return !!orgId ? (
      <FilterChip onDelete={() => handleUpdate(otherFilters)} label={org?.label} />
    ) : null
  },
  acresLt: ({ searchValues, handleUpdate }: FilterChipProps) => (
    <AcresLtChip filters={searchValues} handleUpdate={handleUpdate} />
  ),
  acresGt: ({ searchValues, handleUpdate }: FilterChipProps) => (
    <AcresGtChip filters={searchValues} handleUpdate={handleUpdate} />
  ),
  fips: ({ searchValues, handleUpdate }: FilterChipProps) => (
    <FipsChip filters={searchValues} handleUpdate={handleUpdate} />
  ),
}

export type UserSearchChipName = keyof typeof UserSearchChipComponents
